<template>
  <el-dialog v-loading="isLoading" title="渠道底价设置" :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible"
    top="8vh" :before-close="handleClose" @open="onDialogOpen">
    <template #title>
      <span class="el-dialog__title">
        <span>渠道底价设置</span>
        <span v-if="!!data"> - {{data.Name}}</span>
      </span>
    </template>
    <div class="backgroud-white cs-editor-content">
      <el-collapse class="area-main" v-model="activeCollapses" accordion>
        <div class="price-area" v-for="(item, index) in csapServiceList.filter(m => m.Enable)" :key="index" :name="item.Name">
          <sapService mode="bottomPrice" :isActive="activeCollapses === item.CollapseName" :readonly="readonly" :data="item" :index="index" />
        </div>
      </el-collapse>
      <!-- <div class="price-area" v-for="(item, index) in csapServiceList.filter(m => m.Enable)" :key="index" :name="item.Name">
        <sapService mode="bottomPrice" :readonly="readonly" :data="item" :index="index" />
      </div> -->
    </div>
    <template #footer>
      <div class="dialog-footer popup-footer" v-if="!readonly">
        <el-row>
          <el-col>
            <el-button :disabled="readonly" type="primary" :loading="isSaving" @click="saveChanges">保存</el-button>
          </el-col>
        </el-row>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";
import {
  getChannelSAPServiceList,
  saveChannelBottomPriceSettingList,
} from "@/service/studyAbroad.service";

const default_data = {
  Id: 0,
  Name: null,
};

const mixin_generalMethods = {
  methods: {
    restoreChangedServiceItems() {
      let serviceItemList = this.getChangedServiceItemList();
      serviceItemList.forEach((serviceItem) => {
        Object.copy(serviceItem, serviceItem._originalData);
      });
    },
    updateChangedServiceItems() {
      let serviceItemList = this.getChangedServiceItemList();
      serviceItemList.forEach((serviceItem) => {
        serviceItem.BottomPriceCAD = `${serviceItem.BottomPriceCAD}`.toNumber();
        serviceItem.BottomPriceCNY = `${serviceItem.BottomPriceCNY}`.toNumber();
        serviceItem._originalData = Object.clone(serviceItem, {
          exceptFields: ["_originalData"],
        });
      });
    },
    getChangedServiceItemList() {
      let serviceItemList = [];
      this.csapServiceList.forEach((service) => {
        service.ServiceItems.forEach((serviceItem) => {
          let fixedBottomPriceCAD = `${serviceItem.BottomPriceCAD}`.toNumber();
          let fixedBottomPriceCNY = `${serviceItem.BottomPriceCNY}`.toNumber();
          if (
            fixedBottomPriceCAD !== serviceItem._originalData.BottomPriceCAD ||
            fixedBottomPriceCNY !== serviceItem._originalData.BottomPriceCNY
          ) {
            serviceItemList.push(serviceItem);
            return;
          }

          var pciChanged = serviceItem.PriceCategoryInfos.some((pci) => {
            let fixedBottomPriceCAD = `${pci.BottomPriceCAD}`.toNumber();
            let fixedBottomPriceCNY = `${pci.BottomPriceCNY}`.toNumber();

            let pciOriginal = serviceItem._originalData.PriceCategoryInfos.find(
              (opci) => opci.PriceCategory === pci.PriceCategory
            );
            if (!pciOriginal) return false;

            return (
              pciOriginal.BottomPriceCAD !== fixedBottomPriceCAD ||
              pciOriginal.BottomPriceCNY !== fixedBottomPriceCNY
            );
          });
          if (pciChanged) {
            serviceItemList.push(serviceItem);
            return;
          }
        });
      });
      return serviceItemList;
    },
    getSaveData() {
      let serviceItemList = this.getChangedServiceItemList();
      return serviceItemList.map((serviceItem) => {
        let fixedBottomPriceCAD = `${serviceItem.BottomPriceCAD}`.toNumber();
        let fixedBottomPriceCNY = `${serviceItem.BottomPriceCNY}`.toNumber();

        let priceCategoryInfos = serviceItem.PriceCategoryInfos.map((pci) => {
          let fixedBottomPriceCAD = `${pci.BottomPriceCAD}`.toNumber();
          let fixedBottomPriceCNY = `${pci.BottomPriceCNY}`.toNumber();
          return {
            Id: pci.Id,
            PriceCategory: pci.PriceCategory,
            BottomPriceCAD: fixedBottomPriceCAD,
            BottomPriceCNY: fixedBottomPriceCNY,
            CBPSettingId: pci.CBPSettingId,
          };
        });

        return {
          Id: serviceItem.CBPSettingId,
          ChannelId: serviceItem.ChannelId,
          SAPServiceItemId: serviceItem.Id,
          BottomPriceCAD: fixedBottomPriceCAD,
          BottomPriceCNY: fixedBottomPriceCNY,
          PriceCategoryInfos: priceCategoryInfos,
        };
      });
    },
  },
};

export default {
  name: "channelBottomPriceEditor",
  mixins: [mixinDevice, mixin_generalMethods],
  components: {
    sapService: () => import("./priceManagement/sapService"),
  },
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "800px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(default_data);
      },
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      dialogVisible: false,
      isLoading: false,
      isSaving: false,
      activeCollapses: "",
      csapServiceList: [],
      rules: {},
    };
  },
  created() {
    this.dialogVisible = this.visible;
  },
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    },
    haveChanges() {
      let serviceItemList = this.getChangedServiceItemList();
      return serviceItemList.length > 0;
    },
  },
  methods: {
    // 与服务端交互数据相关方法
    async loadChannelSAPServiceListFromServer() {
      let channelId = !!this.data ? this.data.Id : 0;
      if (!channelId) return;

      this.isLoading = true;
      try {
        let result = await getChannelSAPServiceList(channelId);
        let csapServiceList = !!result && result.success ? result.data : [];
        csapServiceList.forEach((service) => {
          service.CollapseName = `Service_${service.Id}`;
          service.ServiceItems.forEach((serviceItem) => {
            serviceItem._originalData = Object.clone(serviceItem);
          });
        });
        this.csapServiceList = csapServiceList;

        if (this.csapServiceList.length > 0) {
          this.activeCollapses = this.csapServiceList[0].CollapseName;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async saveChannelBottomPriceSettingListToServer(data) {
      this.isSaving = true;
      try {
        let result = await saveChannelBottomPriceSettingList(data);
        if (!!result && result.success && result.data) {
          this.$message({
            message: "保存成功",
            type: "success",
          });

          this.updateChangedServiceItems();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isSaving = false;
      }
    },

    resetData() {
      this.csapServiceList = [];
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    closeDialog(checkChanges) {
      if (checkChanges && this.haveChanges) {
        this.$confirm(`有修改未保存，是否先执行保存？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let saveData = this.getSaveData();
            await this.saveChannelBottomPriceSettingListToServer(saveData);
            this.resetData();
            this.dialogVisible = false;
            this.$emit("visibleChange", this.dialogVisible);
          })
          .catch(() => {
            this.restoreChangedServiceItems();
            this.resetData();
            this.dialogVisible = false;
            this.$emit("visibleChange", this.dialogVisible);
          });
        return;
      }

      this.resetData();
      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.loadChannelSAPServiceListFromServer();
    },
    handleClose(done) {
      this.closeDialog(true);
    },
    saveChanges(e) {
      let saveData = this.getSaveData();

      this.$nextTick(async () => {
        await this.saveChannelBottomPriceSettingListToServer(saveData);
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-editor-content {
  max-height: 450px;
  overflow-y: auto;
  margin: 0 20px;
  .area-main,
  .area-footer {
    margin: 0;
  }

  .price-area {
    padding: 10px;
  }
}
.dialog-footer {
  margin: auto;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/channelBottomPriceEditor.vue